import { createReducer } from './utils';
import {
  handleAvailable,
  handleRequest,
  handleUnavailable,
} from '../reducerHandlers';

import {
  WELCOME_MESSAGE_FAILURE,
  WELCOME_MESSAGE_REQUEST,
  WELCOME_MESSAGE_SUCCESS,
} from './constants';

const defaultState = {
  loading: false,
  message: null,
  errorMessage: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [WELCOME_MESSAGE_REQUEST]: handleRequest,
  [WELCOME_MESSAGE_SUCCESS]: handleAvailable,
  [WELCOME_MESSAGE_FAILURE]: handleUnavailable,
});

// actions

export function getWelcomeMessage(appId, language) {
  return async (dispatch, getState, { services: { authSource } }) => {
    const keyState = 'message';
    const loadingName = 'loading';
    dispatch({
      type: WELCOME_MESSAGE_REQUEST,
      payload: {
        loadingName,
        additionalStates: { errorMessage: null },
      },
    });
    try {
      const { message } = await authSource.getWelcomeMessage(appId, language);
      dispatch({
        type: WELCOME_MESSAGE_SUCCESS,
        payload: {
          keyState,
          data: message,
          loadingName,
          additionalStates: { errorMessage: null },
        },
      });
    } catch (error) {
      // The copy is not required to sign in, so a failure clears the message and
      // lets the screen fall back to its translated title instead of blocking login.
      dispatch({
        type: WELCOME_MESSAGE_FAILURE,
        payload: {
          keyState,
          defaultState: null,
          loadingName,
          additionalStates: { errorMessage: error },
        },
      });
    }
  };
}
